<template>

    <rpm-card-list
        title="Dashboards"
        :data="dashboards"
        :loading="loading"
        grid-class="xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-2"
    >
        <template #functions>
            <section class="w-full flex flex-row-reverse">
                <rpm-button
                    v-if="$can('dashboards.store')"
                    class="w-6 h-6 rounded"
                    tooltip-text="Adicionar"
                    font-size="text-sm"
                    icon="fa-solid fa-plus"
                    @click="openModalCreate()"
                ></rpm-button>
            </section>
        </template>

        <template #badges="{ item }">
            <badge class="bg-sky-500 capitalize"> {{ item.title }}</badge>
        </template>

        <template #actions="{ item }">
            <rpm-button
            v-if="$can('dashboards.destroy')"
            icon="fa-solid fa-trash"
            color="red-hover"
            tooltip-text="Excluir"
            @click="openModalDelete(item)"
            
            ></rpm-button>
            <rpm-button
            v-if="$can('dashboards.update')"
            icon="fa-solid fa-pen-to-square"
            color="transparent"
            tooltip-text="Editar"
            @click="openModalEdit(item)"
            ></rpm-button>
        </template>

        <template #info="{ item }">
            <div class="flex flex-col gap-2">
                <span class="text-md p-2">{{ item.notes }}</span>
                <div class="flex flex-row justify-center">
                        <rpm-button
                            label="Visualizar"
                            @click="routerLink(item.id)"
                        ></rpm-button>
                </div>
            </div>
        </template>
    </rpm-card-list>
    <rpm-modal
		header="Adicionar dashboard"
		class="flex flex-col gap-y-8"
        persist
		:open="modalCreate"
		@close="modalCreate = false"
	>
        <section class="grid grid-cols-2 gap-6">
            <rpm-input
                label="Nome"
                name="title"
                required
                placeholder="Nome da dashboard"
                v-model="form.title"
                :errors="errors.title"
            ></rpm-input>

            <rpm-input
                label="Descrição"
                name="notes"
                required
                placeholder="Descrição da dashboard"
                v-model="form.notes"
                :errors="errors.notes"
            ></rpm-input>
                
            <rpm-input
                type="multiselect"
                label="Perfis"
                name="roles"
                optional
                v-model="form.roles"
                :options="roles"
                optionLabel="name"
                optionValue="id"
            ></rpm-input>

            <rpm-input
                type="multiselect"
                label="Organizações"
                name="organizations"
                optional
                v-model="form.organizations"
                :options="organizations"
                optionLabel="name"
                optionValue="id"
            ></rpm-input>
            
            <rpm-input
                type="textarea"
                label="Configuração"
                name="settings"
                class="col-span-2"
                required
                v-model="form.settings"
                :errors="errors.settings"
            ></rpm-input>
        </section>

        <template #buttons>
            <rpm-button
                label="Confirmar"
                @click="createDashboard()"
            ></rpm-button>
        </template>
	</rpm-modal>

    <rpm-modal
        header="Editar dashboard"
        class="flex flex-col gap-y-8"
        persist
        :open="modalEdit"
        @close="modalEdit = false"
    >
        <section
            class="grid grid-cols-2 gap-6"
        >
            <rpm-input
                label="Nome"
                name="title"
                required
                v-model="form.title"
                :errors="errors.title"
            ></rpm-input>

            <rpm-input
                label="Descrição"
                name="notes"
                required
                v-model="form.notes"
                :errors="errors.notes"
            ></rpm-input>

            <rpm-input
                type="multiselect"
                label="Perfis"
                name="roles"
                optional
                v-model="form.roles"
                :options="roles"
                optionLabel="name"
                optionValue="id"
            ></rpm-input>
            
            <rpm-input
                type="multiselect"
                label="Organizações"
                name="organizations"
                optional
                v-model="form.organizations"
                :options="organizations"
                optionLabel="name"
                optionValue="id"
            ></rpm-input>

            <rpm-input
                type="textarea"
                label="Configuração"
                class="col-span-2"
                required
                name="settings"
                v-model="form.settings"
                :errors="errors.settings"
            ></rpm-input>

        </section>

        <template #buttons>
            <rpm-button
                label="Confirmar"
                @click="editDashboard()"
            ></rpm-button>
        </template >
    </rpm-modal>

    <rpm-modal
        header="Excluir dashboard?"
        class="flex flex-col gap-y-8"
        :open="modalDelete"
        @close="modalDelete = false"
        size="max-w-xl"
    >
        <template #buttons>
            <rpm-button
                color="red"
                label="Excluir"
                @click="deleteDashboard()"
            ></rpm-button>
        </template>
    </rpm-modal>

</template>

<script>

import organizationsRepository from '#repositories/organizationsRepository.js';
import roleRepository from '#repositories/roleRepository.js';
import dashboardRepository from "#repositories/dashboardRepository.js";
import RpmModal from '#components/RpmModal.vue';
import RpmCardList from '#components/RpmCardList.vue';
import Badge from '#components/Badge.vue';
import {getErrors} from '#functions/validator';

export default {
    name: "Dashboards",
    components: {
        RpmModal,
        RpmCardList,
        Badge,
    },
    data() {
        return {
            dashboards: [],
            roles: [],
            organizations: [],
            form: {},
            errors: {},
            loading: false,
            modalCreate: false,
            modalEdit: false,
            modalDelete: false,
            dashboardID: "",
        }
    },
    methods: {
        async getDashboards(useLoading = true) {
            try {
                if(useLoading) this.loading = true;
                this.dashboards = (await dashboardRepository.getDashboards()).data;
                if(useLoading) this.loading = false;
            } catch (error) {
                this.$notify("Um erro ocorreu", 'error');
            }
        },

        openModalCreate() {
            this.form = {
                title: "",
                notes: "",
                roles: [],
                organizations: [], 
                settings: '{ "resource": { "id": "", "url": "", "secret_key": "" } }',
            }
            this.modalCreate = true;
        },

        openModalEdit(item) {
            this.dashboardID = item.id;
            this.form = {
                title: item.title,
                notes: item.notes,
                roles: item.roles ? item.roles : [],
                organizations: item.organizations ? item.organizations : [],
                settings: item.settings ? JSON.stringify(item.settings) : '{ "resource": { "id": "", "url": "", "secret_key": "" } }',
            } 
            this.modalEdit = true;
        },

        openModalDelete(item) {
            this.dashboardID = item.id;
            this.modalDelete = true;
        },

        routerLink(id) {
            this.$router.push({name: "DashboardsShow", params: { dashboard_id: id }})
        },

        async getOrganizations() {
            try {
                this.organizations = (await organizationsRepository.getOrganizations()).data;
            } catch (error) {
                this.$notify('Um erro ocorreu, tente novamente mais tarde.', 'error');
            }
        },

        async getRoles() {
            try {
                this.roles = (await roleRepository.getRoles()).data;
            } catch (error) {
                this.$notify("Um erro ocorreu, tente novamente mais tarde.", 'error');
            }
        },

        createDashboard() {
            dashboardRepository.storeDashboard(this.form).then((response) => {
                this.$notify("Dashboard criada com sucesso!", 'success');
                this.modalCreate = false;
                this.getDashboards(false);
            }).catch((response) => {
                getErrors(this.errors, response.errors);
            });
        },
        
        editDashboard() {
            dashboardRepository.updateDashboard(this.dashboardID, this.form).then((response) => {
                this.$notify("Dashboard editada com sucesso!", 'success');
                this.modalEdit = false;
                this.getDashboards(false);
            }).catch((response) => {
                getErrors(this.errors, response.errors);
            });
        },

        deleteDashboard() {
            dashboardRepository.deleteDashboard(this.dashboardID).then((response) => {
                this.$notify("Dashboard apagada com sucesso!", 'success');
                this.modalDelete = false;
                this.getDashboards(false);
            }).catch((response) => {
                getErrors(this.errors, response.errors);
            });
        },
    },
    async mounted() {
        await this.getDashboards();
        await this.getRoles();
        await this.getOrganizations();
    }
}
// todo item criado com perfil é adicionado como um item no banco de dados mas não é exibido na array de dashboards
// dar stage apenas no index e no dashboardrepository no fim de tudo e apagar estes comentários
</script>